import { useStateContext } from 'context/StateContext'
import { Modal } from 'antd'
import first from 'assets/portfolio/first1.png'
import second from 'assets/portfolio/second.png'
import third from 'assets/portfolio/third.png'
import forth from 'assets/portfolio/forth.png'
import fifth from 'assets/portfolio/fifth.png'
import sixth from 'assets/portfolio/sixth.png'
import { Helmet } from 'react-helmet-async'
import { useState } from 'react'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';

export default function Portfolio() {
    const { darkMode } = useStateContext()
    const [modal2Open, setModal2Open] = useState(false);

    return (
        <>
            <Helmet>
                {/* <Helmet/> component is used to change title, description and tags for each pages. Normally ReactJS use just one "html" file so we can't change title 
        for each page. Helmet is an external library used to add this feature */}
                <meta charSet="utf-8" />
                <title>Steven Eric | Portfolio</title>
            </Helmet>
            <div className='container' id='portfolio-section' data-aos="fade-left">
                <div className="row py-4 first">
                    <div className="col text-style position-relative d-flex justify-content-center">
                        <h1 className={`${darkMode ? "text-body" : "text-body-tertiary"} fw-bold `}>PORTFOLIO</h1>
                        <h4 className='position-absolute align-self-center '>My work</h4>
                    </div>
                </div>
                {/* portfolio section */}
                <div className="row g-4 g-md-3 g-xl-4 px-2 px-md-5 row-cols-1  row-cols-sm-2 row-cols-lg-3 mt-1 mb-5 d-flex align-items-center">
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={first} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Ecommerce</h5>
                                <p className="card-text">Web Design & Development</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-end">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={second} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Real Estate</h5>
                                <p className="card-text">Web Design & Development</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-end">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={fifth} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Social Media</h5>
                                <p className="card-text">Web Design & Development</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-end">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={third} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Blogging</h5>
                                <p className="card-text">Web Design & Development</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-end">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={forth} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Business</h5>
                                <p className="card-text">Web Design & Development</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-end">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={sixth} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">Education</h5>
                                <p className="card-text">Web Design & Development</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-end">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal
                        centered
                        width={800}
                        className='my-3'
                        open={modal2Open}
                        onOk={() => setModal2Open(false)}
                        onCancel={() => setModal2Open(false)}
                        footer={null}
                    >
                        <div className="p-0 p-sm-4">
                            <h3 className='text-center text-info fw-bold'>Ecommerce</h3>
                            <div className='row mt-4'>
                                <div className="col">
                                    <img src={first} className='img-fluid rounded-3' alt="" />
                                </div>
                            </div>
                            <div className="row row-cols-1 row-cols-sm-2 g-3 my-4">
                                <div className="col">

                                    <strong>Project Type:</strong><span> Website</span>
                                </div>
                                <div className="col">
                                    <strong>Technologies:</strong><span> React JS, HTML, JS</span>
                                </div>
                                <div className="col">
                                    <strong>Preview:</strong><span> <a href="#" className='text-decoration-none'>https://themeforest.net/</a></span>
                                </div>
                                <div className="col">
                                    <strong>Client:</strong><span> Envato</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur soluta, cupiditate sequi, fugiat delectus doloribus possimus inventore fuga quis quo est! Id error, ducimus debitis aliquam saepe placeat adipisci fugiat enim nemo quod maiores dicta beatae fuga repudiandae officiis autem a ratione quae vel obcaecati laboriosam corporis. Doloribus aliquam quibusdam sunt delectus modi consequuntur repellat sapiente maiores voluptas, quasi eveniet officiis cum iure vel inventore possimus laudantium? Repellat praesentium molestiae excepturi cumque beatae, non obcaecati exercitationem doloremque aliquam tempore temporibus aperiam eaque eum delectus, modi explicabo pariatur voluptatibus ipsum voluptas unde cum repellendus harum accusamus! Suscipit quia odit laudantium quibusdam?</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur soluta, cupiditate sequi, fugiat delectus doloribus possimus inventore fuga quis quo est! Id error, ducimus debitis aliquam saepe placeat adipisci fugiat enim nemo quod maiores dicta beatae fuga repudiandae officiis autem a ratione quae vel obcaecati laboriosam corporis. Doloribus aliquam quibusdam sunt delectus modi consequuntur repellat sapiente maiores voluptas, quasi eveniet officiis cum iure vel inventore possimus laudantium? Repellat praesentium molestiae excepturi cumque beatae, non obcaecati exercitationem doloremque aliquam tempore temporibus aperiam eaque eum delectus, modi explicabo pariatur voluptatibus ipsum voluptas unde cum repellendus harum accusamus! Suscipit quia odit laudantium quibusdam?</p>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    )
}
